module.exports = __webpack_public_path__ + "static/img/unnax.85a7f203.svg";